<app-navbar></app-navbar>
<main>
  <app-hero></app-hero>
  <app-solutions></app-solutions>
  <app-offshore></app-offshore>
  <app-offline></app-offline>
  <app-detections></app-detections>
  <app-events></app-events>
  <app-use-cases></app-use-cases>
  <app-technology></app-technology>
  <app-about></app-about>
  <app-reasons></app-reasons>
  <app-testimonials></app-testimonials>
  <app-clients></app-clients>
</main>
<app-footer></app-footer>
